import { render, staticRenderFns } from "./contract_draft_service.vue?vue&type=template&id=7872a8c1&scoped=true&"
import script from "./contract_draft_service.vue?vue&type=script&lang=js&"
export * from "./contract_draft_service.vue?vue&type=script&lang=js&"
import style0 from "./contract_draft_service.vue?vue&type=style&index=0&id=7872a8c1&prod&lang=css&"
import style1 from "./contract_draft_service.vue?vue&type=style&index=1&id=7872a8c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7872a8c1",
  null
  
)

export default component.exports